import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    labels: [],
    links: [],
  },
  mutations: {
    setLabels(state, labels) {
      state.labels = labels;
    },
    setLinks(state, links) {
      state.links = links;
    },
  },
  actions: {
    passLabels(context, labels) {
      context.commit('setLabels', labels);
    },
    passLinks(context, links) {
      context.commit('setLinks', links);
    },
  },
});
